import "babel-polyfill";
import './util/polyfill';
import Controller from './controller/controller';
import Episode1 from './page/episode1';
import Legend1 from './page/legend1';
import Legend2 from './page/legend2';
import Legend3 from './page/legend3';
import Legend4 from './page/legend4';
import Myth1 from './page/myth1';
import Intro1 from './page/intro1';
import Skill1 from './page/skill1';
import Reservation1 from './page/reservation1';
import Benefits1 from './page/benefits1';
import Server1 from './page/server1';

CustomEase.create("chr", "M0,0,C0.11,0.494,0.088,0.802,0.142,0.88,0.196,0.952,0.504,1,1,1");

window.loadJsFile = (filename) =>{
  const img = new Image();
  img.src = filename;
}

window.loadJsFile('https://i91.icast-ad.com/track?ccd=4291&mcd=01040601&pcd=10947');

$(document).ready(function () {

  let controller;
  const pagesInfo = [
    {
      key: 'episode',
      ele: document.querySelector('.episode'),
      motionType: 'vertical',
      sub: [
        {
          key: 'episode1',
          ele: document.querySelector('.episode1'),
          className: Episode1
        }
      ]
    },
    {
      key: 'legend',
      ele: document.querySelector('.legend'),
      motionType: 'vertical',
      sub: [
        {
          key: 'legend1',
          ele: document.querySelector('.legend1'),
          motionType: 'horizontal',
          className: Legend1
        },
        {
          key: 'legend2',
          ele: document.querySelector('.legend2'),
          motionType: 'horizontal',
          className: Legend2
        },
        {
          key: 'legend3',
          ele: document.querySelector('.legend3'),
          motionType: 'horizontal',
          className: Legend3
        },
        {
          key: 'legend4',
          ele: document.querySelector('.legend4'),
          motionType: 'horizontal',
          className: Legend4
        }
      ]
    },
   {
      key: 'myth',
      ele: document.querySelector('.myth'),
      motionType: 'vertical',
      sub: [
        {
          key: 'myth1',
          ele: document.querySelector('.myth1'),
          className: Myth1
        }
      ]
    },
   {
      key: 'intro',
      ele: document.querySelector('.intro'),
      motionType: 'vertical',
      sub: [
        {
          key: 'intro1',
          ele: document.querySelector('.intro1'),
          className: Intro1
        }
      ]
    },
    {
     key: 'skill',
     ele: document.querySelector('.skill'),
     motionType: 'vertical',
     sub: [
       {
         key: 'skill1',
         ele: document.querySelector('.skill1'),
         className: Skill1
       }
     ]
   },
   {
      key: 'reservation',
      ele: document.querySelector('.reservation'),
      motionType: 'vertical',
      sub: [
        {
          key: 'reservation1',
          ele: document.querySelector('.reservation1'),
          className: Reservation1
        }
      ]
    },
    {
      key: 'benefits',
      ele: document.querySelector('.benefits'),
      motionType: 'vertical',
      sub: [
        {
          key: 'benefits1',
          ele: document.querySelector('.benefits1'),
          className: Benefits1
        }
      ]
    },
    {
      key: 'server',
      ele: document.querySelector('.server'),
      motionType: 'vertical',
      sub: [
        {
          key: 'server1',
          ele: document.querySelector('.server1'),
          className: Server1
        }
      ]
    }
  ]


  new nc.promokit.Preloader({
    'game': 'lineage',
    'delay': 500,
    'image': [
      '/promo/lineage/history/2019/190619_fencer/img/episode_txt_1.png',
      '/promo/lineage/history/2019/190619_fencer/img/episode_txt_2.png',
      '/promo/lineage/history/2019/190619_fencer/img/episode_txt_3.png',
      '/promo/lineage/history/2019/190619_fencer/img/episode_txt_3_ef.png',

      '/promo/lineage/history/2019/190619_fencer/img/legend_bg.jpg',
      '/promo/lineage/history/2019/190619_fencer/img/legend_bg_ef.jpg',
      '/promo/lineage/history/2019/190619_fencer/img/legend_txt_1.png',
      '/promo/lineage/history/2019/190619_fencer/img/legend_txt_1_ef.png',
      '/promo/lineage/history/2019/190619_fencer/img/legend_txt_2.png',
      '/promo/lineage/history/2019/190619_fencer/img/legend_obj_bg1.png',
      '/promo/lineage/history/2019/190619_fencer/img/legend_obj_bg2.png',

      '/promo/lineage/history/2019/190619_fencer/img/legend1_chr1.png',
      '/promo/lineage/history/2019/190619_fencer/img/legend1_chr1_ef.png',
      '/promo/lineage/history/2019/190619_fencer/img/legend1_chr2.png',
      '/promo/lineage/history/2019/190619_fencer/img/legend1_chr2_ef.png',
      '/promo/lineage/history/2019/190619_fencer/img/legend1_obj_1_icon.png',
      '/promo/lineage/history/2019/190619_fencer/img/legend1_obj_1_icon_ef.png',
      '/promo/lineage/history/2019/190619_fencer/img/legend1_obj_1_txt.png',
      '/promo/lineage/history/2019/190619_fencer/img/legend1_obj_2_icon.png',
      '/promo/lineage/history/2019/190619_fencer/img/legend1_obj_2_icon_ef.png',
      '/promo/lineage/history/2019/190619_fencer/img/legend1_obj_2_txt.png',

      '/promo/lineage/history/2019/190619_fencer/img/legend2_chr1.png',
      '/promo/lineage/history/2019/190619_fencer/img/legend2_chr1_ef.png',
      '/promo/lineage/history/2019/190619_fencer/img/legend2_chr2.png',
      '/promo/lineage/history/2019/190619_fencer/img/legend2_chr2_ef.png',
      '/promo/lineage/history/2019/190619_fencer/img/legend2_obj_1_icon.png',
      '/promo/lineage/history/2019/190619_fencer/img/legend2_obj_1_icon_ef.png',
      '/promo/lineage/history/2019/190619_fencer/img/legend2_obj_1_txt.png',
      '/promo/lineage/history/2019/190619_fencer/img/legend2_obj_2_icon.png',
      '/promo/lineage/history/2019/190619_fencer/img/legend2_obj_2_icon_ef.png',
      '/promo/lineage/history/2019/190619_fencer/img/legend2_obj_2_txt.png',

      '/promo/lineage/history/2019/190619_fencer/img/legend3_chr1.png',
      '/promo/lineage/history/2019/190619_fencer/img/legend3_chr1_ef.png',
      '/promo/lineage/history/2019/190619_fencer/img/legend3_chr2.png',
      '/promo/lineage/history/2019/190619_fencer/img/legend3_chr2_ef.png',
      '/promo/lineage/history/2019/190619_fencer/img/legend3_obj_1_icon.png',
      '/promo/lineage/history/2019/190619_fencer/img/legend3_obj_1_icon_ef.png',
      '/promo/lineage/history/2019/190619_fencer/img/legend3_obj_1_txt.png',
      '/promo/lineage/history/2019/190619_fencer/img/legend3_obj_2_icon.png',
      '/promo/lineage/history/2019/190619_fencer/img/legend3_obj_2_icon_ef.png',
      '/promo/lineage/history/2019/190619_fencer/img/legend3_obj_2_txt.png',

      '/promo/lineage/history/2019/190619_fencer/img/legend4_chr1.png',
      '/promo/lineage/history/2019/190619_fencer/img/legend4_chr1_ef.png',
      '/promo/lineage/history/2019/190619_fencer/img/legend4_chr2.png',
      '/promo/lineage/history/2019/190619_fencer/img/legend4_chr2_ef.png',
      '/promo/lineage/history/2019/190619_fencer/img/legend4_obj_1_icon.png',
      '/promo/lineage/history/2019/190619_fencer/img/legend4_obj_1_icon_ef.png',
      '/promo/lineage/history/2019/190619_fencer/img/legend4_obj_1_txt.png',
      '/promo/lineage/history/2019/190619_fencer/img/legend4_obj_2_icon.png',
      '/promo/lineage/history/2019/190619_fencer/img/legend4_obj_2_icon_ef.png',
      '/promo/lineage/history/2019/190619_fencer/img/legend4_obj_2_txt.png',

      '/promo/lineage/history/2019/190619_fencer/img/myth1_bg.jpg',
      '/promo/lineage/history/2019/190619_fencer/img/myth_obj_1.png',
      '/promo/lineage/history/2019/190619_fencer/img/myth_obj_1_ef.png',
      '/promo/lineage/history/2019/190619_fencer/img/myth_obj_2.png',
      '/promo/lineage/history/2019/190619_fencer/img/myth_obj_2_ef.png',
      '/promo/lineage/history/2019/190619_fencer/img/myth1_tab_bg.png',
      '/promo/lineage/history/2019/190619_fencer/img/myth1_txt_1.png',
      '/promo/lineage/history/2019/190619_fencer/img/myth1_txt_1_ef.png',
      '/promo/lineage/history/2019/190619_fencer/img/myth1_txt_2.png',

      '/promo/lineage/history/2019/190619_fencer/img/intro1_bg.jpg',
      '/promo/lineage/history/2019/190619_fencer/img/intro1_chr1.png',
      '/promo/lineage/history/2019/190619_fencer/img/intro1_chr1_ef.png',
      '/promo/lineage/history/2019/190619_fencer/img/intro1_slide_img_1.png',
      '/promo/lineage/history/2019/190619_fencer/img/intro1_slide_img_2.png',
      '/promo/lineage/history/2019/190619_fencer/img/intro1_slide_img_3.png',
      '/promo/lineage/history/2019/190619_fencer/img/intro1_slide_img_4.png',
      '/promo/lineage/history/2019/190619_fencer/img/intro1_slide_img_0.png',
      '/promo/lineage/history/2019/190619_fencer/img/intro1_txt_1.png',
      '/promo/lineage/history/2019/190619_fencer/img/intro1_txt_1_ef.png',

      '/promo/lineage/history/2019/190619_fencer/img/skill1_bg.jpg',
      '/promo/lineage/history/2019/190619_fencer/img/skill1_chr1.png',
      '/promo/lineage/history/2019/190619_fencer/img/skill1_chr1_ef.png',
      '/promo/lineage/history/2019/190619_fencer/img/skill1_menus_1_bg_l.png',
      '/promo/lineage/history/2019/190619_fencer/img/skill1_menus_1_bg_r.png',
      '/promo/lineage/history/2019/190619_fencer/img/skill1_menus_2.png',
      '/promo/lineage/history/2019/190619_fencer/img/skill1_menus_2_bg_l.png',
      '/promo/lineage/history/2019/190619_fencer/img/skill1_menus_2_bg_r.png',
      '/promo/lineage/history/2019/190619_fencer/img/skill1_menus_2_bg_r2.png',
      '/promo/lineage/history/2019/190619_fencer/img/skill1_txt_1.png',
      '/promo/lineage/history/2019/190619_fencer/img/skill1_txt_1_ef.png',
      '/promo/lineage/history/2019/190619_fencer/img/skill1_txt_2.png',

      '/promo/lineage/history/2019/190619_fencer/img/reservation1_bg.jpg',
      '/promo/lineage/history/2019/190619_fencer/img/reservation1_chr1.png',
      '/promo/lineage/history/2019/190619_fencer/img/reservation1_chr1_ef.png',
      '/promo/lineage/history/2019/190619_fencer/img/reservation1_btns.png',
      '/promo/lineage/history/2019/190619_fencer/img/reservation1_layer.png',
      '/promo/lineage/history/2019/190619_fencer/img/reservation1_layer2.jpg',
      '/promo/lineage/history/2019/190619_fencer/img/reservation1_txt_1.png',
      '/promo/lineage/history/2019/190619_fencer/img/reservation1_txt_1_ef.png',
      '/promo/lineage/history/2019/190619_fencer/img/reservation1_txt_2.png',
      '/promo/lineage/history/2019/190619_fencer/img/reservation1_txt_3.png',

      '/promo/lineage/history/2019/190619_fencer/img/server1_bg.jpg',
      '/promo/lineage/history/2019/190619_fencer/img/server1_chr1.png',
      '/promo/lineage/history/2019/190619_fencer/img/server1_chr1_ef.png',
      '/promo/lineage/history/2019/190619_fencer/img/server1_layer.jpg',
      '/promo/lineage/history/2019/190619_fencer/img/server1_slide1.png',
      '/promo/lineage/history/2019/190619_fencer/img/server1_slide2.png',
      '/promo/lineage/history/2019/190619_fencer/img/server1_txt_1.png',
      '/promo/lineage/history/2019/190619_fencer/img/server1_txt_1_ef.png',
      '/promo/lineage/history/2019/190619_fencer/img/server1_txt_2.png',

      '/promo/lineage/history/2019/190619_fencer/img/benefits1_bg.jpg',
      '/promo/lineage/history/2019/190619_fencer/img/benefits1_chr1.png',
      '/promo/lineage/history/2019/190619_fencer/img/benefits1_chr1_ef.png',
      '/promo/lineage/history/2019/190619_fencer/img/benefits1_card_1_bg.png',
      '/promo/lineage/history/2019/190619_fencer/img/benefits1_card_1_chr.png',
      '/promo/lineage/history/2019/190619_fencer/img/benefits1_card_1_txt.png',
      '/promo/lineage/history/2019/190619_fencer/img/benefits1_card_2_bg.png',
      '/promo/lineage/history/2019/190619_fencer/img/benefits1_card_2_chr1.png',
      '/promo/lineage/history/2019/190619_fencer/img/benefits1_card_2_chr2.png',
      '/promo/lineage/history/2019/190619_fencer/img/benefits1_card_2_txt.png',
      '/promo/lineage/history/2019/190619_fencer/img/benefits1_txt_1.png',
      '/promo/lineage/history/2019/190619_fencer/img/benefits1_txt_1_ef.png',
      '/promo/lineage/history/2019/190619_fencer/img/benefits1_txt_2.png',

    ],
    video:[
      "https://vod.plaync.com/lineage/episode1/episode1_bg.mp4"
    ]
  });

  controller = new Controller(pagesInfo);
  $(document).on('preloadend', function () {
    controller.init();
    $('.loding_bg').remove();

  });
});




// WEBPACK FOOTER //
// ./src/js/index.js